// Single cents→display conversion so amounts coming from the payments
// backend (always integer cents) can never be formatted inconsistently.
export function formatCentsUSD(amountCents: number): string {
  return `$${(amountCents / 100).toFixed(2)}`;
}
